import { createRequiredValidators } from "@xo/client-common";
import { Type10Mixed } from "./Type10Mixed";

export function createType10MixedValidators() {
    return [
        ...createRequiredValidators<Type10Mixed>(["stringField", "stringArrayField", "longStringField", "longStringArrayField", "numberField", "numberArrayField", "fractionField", "fractionArrayField", "booleanArrayField", "dateField", "dateArrayField", "timeField", "timeArrayField", "timestampField", "timestampArrayField"]),
    ];
}
